import React, { useState, useEffect } from 'react';
import './Preloader.css';


const Preloader = ({ onFinish }) => {
  // State untuk mengontrol kapan preloader mulai menghilang (fade out)
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    // Timer untuk memulai animasi fade-out (lebih cepat: 1.5 detik)
    const hideTimeout = setTimeout(() => {
      setIsHiding(true);
    }, 1500);

    // Timer untuk memanggil onFinish setelah animasi fade-out selesai.
    const destroyTimeout = setTimeout(() => {
      onFinish();
    }, 2250); // Total durasi: 2.25 detik

    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(destroyTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Dijalankan sekali saat komponen pertama kali render

  return (
    <div className={`preloader ${isHiding ? 'hidden' : ''}`}>
      <div className="preloader-content">
        <div className="ripple-loader">
          <div></div>
          <div></div>
        </div>
        <p className="preloader-text">Sedang memuat data...</p>
      </div>
    </div>
  );
};

export default Preloader;
